import { useEffect } from "react";
import { usePageTitleOverride } from "context/PageTitleProvider";

/**
 * Sets an entity-specific browser-tab title for the current page once data is
 * available (e.g. `usePageTitle(submittal && `${submittal.number} — ${submittal.title}`)`).
 *
 * Pass `undefined` while loading; the route's static title (from
 * `config/page-titles`) is shown until a value is provided. The override is
 * automatically discarded on navigation, so there is nothing to clean up.
 */
export function usePageTitle(page: string | undefined): void {
  const { setPageTitle } = usePageTitleOverride();

  useEffect(() => {
    if (page) setPageTitle(page);
  }, [page, setPageTitle]);
}

export default usePageTitle;
